import React, { useContext, useEffect, useState } from "react";
import LoadingSpinner from "../../components/loader/LoadingSpinner";
import SEO from "../../components/SEO/SEO";
import OcBanner from "./banner/Banner";
import Banner from "../home-page/banner/Banner";
import AdvancedFacilitiesList from "../branch-page/advanced-facilities/AdvancedFacilitiesList";
import ExperienceExcellence from "../branch-page/experience-excellence/ExperienceExcellence";
import AboutUs from "../home-page/about-us/AboutUs";
import ForeignPatients from "../home-page/new-widgets/foreign-patients/ForeignPatients";
import HighEndLabServices from "../home-page/new-widgets/high-end-lab-services/HighEndLabServices";
import AuxilaryServices from "../home-page/new-widgets/auxilary-services/AuxilaryServices";
import AdvancedFertility from "../home-page/new-widgets/advanced-fertility/AdvancedFertility";
import ChildHealth from "../home-page/new-widgets/child-health/ChildHealth";
import HighestIvfCycles from "../home-page/new-widgets/highest-ivf-cycles/HighestIvfCycles";
import MedicalTravel from "../home-page/new-widgets/medical-travel/MedicalTravel";
import HealthCheck from "../home-page/new-widgets/health-check/HealthCheck";
import HighRiskPregnancy from "../home-page/new-widgets/high-risk-pregnancy/HighRiskPregnancy";
import DoctorsMessage from "../home-page/new-widgets/doctors-message/DoctorsMessage";
import VideoTestimonialsNew from "../home-page/video-testimonials-new/VideoTestimonialsNew";
import GalleryList from "../home-page/gallery-list/GalleryList";
import VideoTestimonial from "../home-page/video-testimonial/VideoTestimonial";
import BlogsList from "../home-page/blogs/BlogsList";
import ForeignList from "../home-page/foreign-guests/ForeignList";
import Services from "../home-page/services/Services";
import DoctorsList from "../home-page/doctors-list/DoctorsList";
import TestimonialWidget from "../home-page/new-widgets/testimonial-widget/TestimonialWidget";
import useDeviceWidth from "../../components/device-width/UseDeviceWidth";
import { useSelector } from "react-redux";
import { NavigationContext } from "../../App";
import { useNavigationType } from "react-router-dom";
import AdvancedIvfLab from "../home-page/new-widgets/advanced-ivf-lab/AdvancedIvfLab";
import LeadPosition from "../home-page/new-widgets/lead-position/LeadPosition";
import WhoCanChooseUs from "./who-can-choose-us/WhoCanChooseUs";
import StaticSection from "./static-section/StaticSection";
import FaqWidget from "./faq-widget/FaqWidget";
import styles from "./OnlineConsultation.module.css";
import Branches from "../home-page/branch-slider/Branches";
import BookAppointment from "./book-appointment/BookAppointment";

const OnlineConsultation = () => {
  const [loading, setLoading] = useState(true);
  const width = useDeviceWidth();
  const { isBackNavigation } = useContext(NavigationContext);
  const navigate = useNavigationType();
  const { widgets } = useSelector((state) => state.widget); // Access widget data
  const [widgetData, setWidgetData] = useState([]);

  useEffect(() => {
    setLoading(true);
    if (widgets?.widgets) {
      const data = widgets?.widgets?.filter(
        (item) => item?.WidgetScope == "Online Consultation"
      );
      setWidgetData(data);
      setLoading(false);
    }
  }, [widgets]);

  console.log("online consultation page widgets", widgetData);

  useEffect(() => {
    if (widgetData?.length > 0 && isBackNavigation) {
      const origin = sessionStorage.getItem("scrollOrigin");
      const targetY = sessionStorage.getItem("scrollTargetY");

      if (origin !== "online-consultation" || !targetY) return;

      const scrollY = parseInt(targetY, 10);
      if (isNaN(scrollY)) return;

      const maxAttempts = 10;
      let attempts = 0;

      const tryScroll = () => {
        window.scrollTo({
          top: scrollY,
          behavior: "smooth", // Use 'smooth' if desired
        });

        const currentY = Math.round(window.scrollY);
        const isInPosition = Math.abs(currentY - scrollY) < 5;

        if (!isInPosition && attempts < maxAttempts) {
          attempts++;
          setTimeout(tryScroll, 100);
        }
      };

      tryScroll();

      // Optional: clear the session storage after use
      sessionStorage.removeItem("scrollTargetY");
      sessionStorage.removeItem("scrollOrigin");
    }
  }, [widgetData]);

  return (
    <>
      {loading && <LoadingSpinner />}
      {/* <BookAppointment /> */}
      {/* <StaticSection /> */}
      <SEO />
      <div>
        {widgetData?.map((item) => {
          // Determine if the component should be shown based on device type
          const shouldShowOnDesktop = item?.deviceType?.includes("Desktop");
          const shouldShowOnMobile = item?.deviceType?.includes("Mobile");

          // Render based on the device type and the current device
          if (shouldShowOnDesktop && width > 600) {
            if (item.type === "Banner Home") {
              return <Banner data={item} />;
            } else if (item.type === "Banner Online Consultation") {
              return <OcBanner data={item} />;
            } else if (item.type === "FAQ") {
              return <FaqWidget data={item} />;
            } else if (
              item.type === "Page" &&
              item?.designType[0] == "ADVANCED FACILITIES WIDGET"
            ) {
              return <AdvancedFacilitiesList data={item} />;
            } else if (
              item.type === "Page" &&
              item?.designType[0] == "ADVANCED IVF LAB WIDGET"
            ) {
              return <AdvancedIvfLab data={item} />;
            } else if (
              item.type === "Page" &&
              item?.designType[0] == "LEADING POSITION WIDGET"
            ) {
              return <LeadPosition data={item} />;
            } else if (
              item.type === "Page" &&
              item?.designType[0] == "ABOUT US WIDGET"
            ) {
              return <ExperienceExcellence data={item} />;
            } else if (
              item.type === "Page" &&
              item?.designType[0] == "ABOUT US HOME WIDGET"
            ) {
              return <AboutUs data={item} />;
            } else if (
              item.type === "Page" &&
              item?.designType[0] == "FOREIGN PATIENTS WIDGET"
            ) {
              return <ForeignPatients data={item} />;
            } else if (
              item.type === "Page" &&
              item?.designType[0] == "HIGH END LAB SERVICES WIDGET"
            ) {
              return <HighEndLabServices data={item} />;
            } else if (
              item.type === "Page" &&
              item?.designType[0] == "AUXILIARY SERVICES WIDGET"
            ) {
              return <AuxilaryServices data={item} />;
            } else if (
              item.type === "Page" &&
              item?.designType[0] == "ADVANCED FERTILITY TREATMENTS WIDGET"
            ) {
              return <AdvancedFertility data={item} />;
            } else if (
              item.type === "Page" &&
              item?.designType[0] == "CHILD HEALTH WIDGET"
            ) {
              return <ChildHealth data={item} />;
            } else if (
              item.type === "Page" &&
              item?.designType[0] == "HIGHEST IVF CYCLES WIDGET"
            ) {
              return <HighestIvfCycles data={item} />;
            } else if (
              item.type === "Page" &&
              item?.designType[0] == "MEDICAL TRAVEL WIDGET"
            ) {
              return <MedicalTravel data={item} />;
            } else if (
              item.type === "Page" &&
              item?.designType[0] == "HEALTH CHECK WIDGET"
            ) {
              return <HealthCheck data={item} />;
            } else if (
              item.type === "Page" &&
              item?.designType[0] == "HIGH RISK PREGNANCY WIDGET"
            ) {
              return <HighRiskPregnancy data={item} />;
            } else if (
              item.type === "Page" &&
              item?.categoryName == "Chairman Message"
            ) {
              return <DoctorsMessage data={item} />;
            } else if (item.type === "Youtube Shorts") {
              return <VideoTestimonialsNew data={item} />;
            } else if (item.type === "Gallery") {
              return <GalleryList data={item} />;
            } else if (
              item.type === "Testimonial" &&
              item?.testimonialType == "VIDEO"
            ) {
              return <VideoTestimonial data={item} />;
            } else if (item.type === "Page" && item?.categoryName == "Blogs") {
              return <BlogsList data={item} />;
            } else if (
              item.type === "Page" &&
              item?.categoryName == "Custom Page" &&
              item?.designType[0] == "MISCELLANEOUS WIDGET"
            ) {
              return <ForeignList data={item} />;
            } else if (item.type === "Services") {
              return <Services data={item} />;
            } else if (item.type === "Doctors") {
              return <DoctorsList data={item} />;
            } else if (
              item.type === "Testimonial" &&
              item?.testimonialType == "CONTENT"
            ) {
              return <TestimonialWidget data={item} />;
            } else if (item.type === "Who Can Choose Us") {
              return <WhoCanChooseUs data={item} />;
            } else if (item.type === "Branch") {
              return <Branches data={item} />;
            } else if (item.type === "Book an appointment") {
              return <BookAppointment data={item} />;
            } else if (item.type === "Static") {
              return (
                <div
                  className="home-static"
                  dangerouslySetInnerHTML={{ __html: item?.staticContent }}
                ></div>
              );
            } else {
              // return <div key={item._id}>Unknown Type</div>;
            }
          } else if (shouldShowOnMobile && width <= 768) {
            // Similar conditional rendering for mobile
            if (item.type === "Banner Home") {
              return <Banner data={item} />;
            } else if (item.type === "Banner Online Consultation") {
              return <OcBanner data={item} />;
            } else if (item.type === "FAQ") {
              return <FaqWidget data={item} />;
            } else if (
              item.type === "Page" &&
              item?.designType[0] == "ADVANCED FACILITIES WIDGET"
            ) {
              return <AdvancedFacilitiesList data={item} />;
            } else if (
              item.type === "Page" &&
              item?.designType[0] == "ADVANCED IVF LAB WIDGET"
            ) {
              return <AdvancedIvfLab data={item} />;
            } else if (
              item.type === "Page" &&
              item?.designType[0] == "LEADING POSITION WIDGET"
            ) {
              return <LeadPosition data={item} />;
            } else if (
              item.type === "Page" &&
              item?.designType[0] == "ABOUT US WIDGET"
            ) {
              return <ExperienceExcellence data={item} />;
            } else if (
              item.type === "Page" &&
              item?.designType[0] == "ABOUT US HOME WIDGET"
            ) {
              return <AboutUs data={item} />;
            } else if (
              item.type === "Page" &&
              item?.designType[0] == "FOREIGN PATIENTS WIDGET"
            ) {
              return <ForeignPatients data={item} />;
            } else if (
              item.type === "Page" &&
              item?.designType[0] == "HIGH END LAB SERVICES WIDGET"
            ) {
              return <HighEndLabServices data={item} />;
            } else if (
              item.type === "Page" &&
              item?.designType[0] == "AUXILIARY SERVICES WIDGET"
            ) {
              return <AuxilaryServices data={item} />;
            } else if (
              item.type === "Page" &&
              item?.designType[0] == "ADVANCED FERTILITY TREATMENTS WIDGET"
            ) {
              return <AdvancedFertility data={item} />;
            } else if (
              item.type === "Page" &&
              item?.designType[0] == "CHILD HEALTH WIDGET"
            ) {
              return <ChildHealth data={item} />;
            } else if (
              item.type === "Page" &&
              item?.designType[0] == "HIGHEST IVF CYCLES WIDGET"
            ) {
              return <HighestIvfCycles data={item} />;
            } else if (
              item.type === "Page" &&
              item?.designType[0] == "MEDICAL TRAVEL WIDGET"
            ) {
              return <MedicalTravel data={item} />;
            } else if (
              item.type === "Page" &&
              item?.designType[0] == "HEALTH CHECK WIDGET"
            ) {
              return <HealthCheck data={item} />;
            } else if (
              item.type === "Page" &&
              item?.designType[0] == "HIGH RISK PREGNANCY WIDGET"
            ) {
              return <HighRiskPregnancy data={item} />;
            } else if (
              item.type === "Page" &&
              item?.categoryName == "Chairman Message"
            ) {
              return <DoctorsMessage data={item} />;
            } else if (item.type === "Youtube Shorts") {
              return <VideoTestimonialsNew data={item} />;
            } else if (item.type === "Gallery") {
              return <GalleryList data={item} />;
            } else if (
              item.type === "Testimonial" &&
              item?.testimonialType == "VIDEO"
            ) {
              return <VideoTestimonial data={item} />;
            } else if (item.type === "Page" && item?.categoryName == "Blogs") {
              return <BlogsList data={item} />;
            } else if (
              item.type === "Page" &&
              item?.categoryName == "Custom Page" &&
              item?.designType[0] == "MISCELLANEOUS WIDGET"
            ) {
              return <ForeignList data={item} />;
            } else if (item.type === "Services") {
              return <Services data={item} />;
            } else if (item.type === "Doctors") {
              return <DoctorsList data={item} />;
            } else if (
              item.type === "Testimonial" &&
              item?.testimonialType == "CONTENT"
            ) {
              return <TestimonialWidget data={item} />;
            } else if (item.type === "Who Can Choose Us") {
              return <WhoCanChooseUs data={item} />;
            } else if (item.type === "Branch") {
              return <Branches data={item} />;
            } else if (item.type === "Book an appointment") {
              return <BookAppointment data={item} />;
            } else if (item.type === "Static") {
              return (
                <div
                  className="home-static"
                  dangerouslySetInnerHTML={{ __html: item?.staticContent }}
                ></div>
              );
            } else {
              // return <div key={item._id}>Unknown Type</div>;
            }
          } else {
            return null; // Do not render anything if the device type does not match
          }
        })}
      </div>
    </>
  );
};

export default OnlineConsultation;
